export {ModalService} from './modal/modal.service'
export {SharedModule} from './shared.module'